import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  name: {
    id: 'survey.list.name',
    defaultMessage: 'Name',
  },
  nameVersion: {
    id: 'survey.list.nameVersion',
    defaultMessage: '{name} ({version})',
  },
  description: {
    id: 'survey.list.description',
    defaultMessage: 'Description',
  },
  version: {
    id: 'survey.list.version',
    defaultMessage: 'Version',
  },
  type: {
    id: 'survey.list.type',
    defaultMessage: 'Type',
  },
  internal: {
    id: 'survey.list.type.internal',
    defaultMessage: 'Internal',
  },
  status: {
    id: 'survey.list.status',
    defaultMessage: 'Status',
  },
  unknown: {
    id: 'survey.list.status.unknown',
    defaultMessage: 'Unknown',
  },
  createFailure: {
    id: 'survey.list.create.failure',
    defaultMessage: 'An error occurred while creating the survey',
  },
  surveyResultsTooltip: {
    id: 'survey.list.surveyResultsTooltip',
    defaultMessage: 'Navigate to Survey Results',
  },
  all: {
    id: 'survey.filter.status.all',
    defaultMessage: 'All',
  },
  draft: {
    id: 'survey.filter.status.draft',
    defaultMessage: 'Draft',
  },
  active: {
    id: 'survey.filter.status.active',
    defaultMessage: 'Published',
  },
  retired: {
    id: 'survey.filter.status.retired',
    defaultMessage: 'Archived',
  },
  surveyStatus: {
    id: 'survey.filter.surveyStatus.headerLabel',
    defaultMessage: 'Survey Status',
  },
  createSuccess: {
    id: 'survey.list.create.success',
    defaultMessage: 'Successfully created the survey',
  },
  title: {
    id: 'survey.list.title',
    defaultMessage: 'Surveys',
  },
  createSurvey: {
    id: 'survey.list.newSurvey',
    defaultMessage: 'Create Survey',
  },
  surveysCount: {
    id: 'survey.list.count',
    defaultMessage: '{count} {count, plural, one {Survey} other {Surveys}}',
  },
  statusOptions: {
    id: 'survey.filter.status.options',
    defaultMessage: 'Status options',
  },
  search: {
    id: 'survey.search',
    defaultMessage: 'Survey name or survey description',
  },
});
